module.exports = __webpack_public_path__ + "img/valorant.2417370e.svg";